import { useParams } from "react-router-dom";

import QuizAttemptScreen from "../QuizAttemptScreen";

import { useGetAttemptByIdQuery } from "../../../slices/quizAttemptApiSlice";

const QuizAttemptLoader = () => {
  const { attemptId } = useParams();

  const {
    data: attempt,
    isLoading,
    error,
  } = useGetAttemptByIdQuery(attemptId, {
    skip: !attemptId,
  });
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="rounded-xl bg-blue-100 p-5 text-blue-700">
          Generating quiz paper...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="rounded-xl bg-red-100 p-5 text-red-700">
          {error?.data?.message || "Unable to load quiz attempt"}
        </div>
      </div>
    );
  }

  if (!attempt) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="rounded-xl bg-yellow-100 p-5 text-yellow-700">
          Quiz attempt not found
        </div>
      </div>
    );
  }

  return <QuizAttemptScreen quiz={attempt.quiz} attempt={attempt} />;
};

export default QuizAttemptLoader;
